import { render, staticRenderFns } from "./InitLoader.vue?vue&type=template&id=0e9578bc"
import script from "./InitLoader.vue?vue&type=script&lang=js"
export * from "./InitLoader.vue?vue&type=script&lang=js"
import style0 from "./InitLoader.vue?vue&type=style&index=0&id=0e9578bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports